import React, { useEffect } from "react";
import * as BosIdentityServices from "data/BosWebServices/BosIdentityServices";
import LoginHeader from "./LoginHeader";
import { getTranslation as translate } from "logic/LocaleManager";

import { LOGINTYPE_LOGIN, LOGINTYPE_TOKENLOGIN } from "pages/Login/LoginPage";

// Redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as bosUserActions from "../../redux/actions/bosUserActions";

function TokenLogin(props) {
  const { changeLoginType, loginToken, actionSuccessfull, actionError, setIsLoading } = props;
  const registerFailedText = translate("loginToken.failed", "Login failed!");

  useEffect(() => {
    if (loginToken)
      tokenLogin(loginToken);
    else
      gotoLogin();
  }, [loginToken]);

  async function tokenLogin(token) {
    try {
      setIsLoading(true);
      let result = await BosIdentityServices.fetchOneTimeTokenAuthentication(token);
      if (!result || !result.token) throw new Error("NO TOKEN RECEIVED");
      props.bosUserActions.setBosUser({
        newDisplayName: result.userDisplayName,
        newAuthToken: result.token,
        newPersistIn: "session"
      });
      actionSuccessfull(LOGINTYPE_TOKENLOGIN, result.startUri, null, result.enableLaunchpad);
    } catch (error) {
      props.bosUserActions.clearBosUser();
      actionError(registerFailedText + " (" + error + ")");
      setIsLoading(false);
    }
  }

  function gotoLogin() {
    changeLoginType(LOGINTYPE_LOGIN);
  }

  return (
    <LoginHeader title={translate("loginToken.title", "Logging in")} description={translate("loginToken.description", "Checking Token...")} />
  );
}

function mapDispatchToProps(dispatch) {
  return {
    bosUserActions: bindActionCreators(bosUserActions, dispatch)
  };
}

export default connect(
  null,
  mapDispatchToProps
)(TokenLogin);
